const dsFields = [
    {value: 'TOP', label: 'Топография'},
    {value: 'MORPH', label: 'Морфология'},
    {value: 'STAGE', label: 'Стадия'},
    {value: 'TNM_T', label: 'TNM_T'},
    {value: 'TNM_N', label: 'TNM_N'},
    {value: 'TNM_M', label: 'TNM_M'},

    {value: 'GRADE', label: 'Grade'},
    {value: 'SpecTreat', label: 'Спеицальное лечение'},
]
const patientFields = [
    {value: 'AGE', label: 'Возраст'},
    {value: 'INVALID', label: 'Инвалдиность'},
    {value: 'SEX', label: 'Пол'},
]
const eventFields = [
    {value: 'TOP', label: 'Тип события'},
    {value: 'TOP', label: 'Топография'},
    {value: 'MORPH', label: 'Морфология'},
    {value: 'STAGE', label: 'Стадия'},
    {value: 'TNM_T', label: 'TNM_T'},
    {value: 'TNM_N', label: 'TNM_N'},
    {value: 'TNM_M', label: 'TNM_M'},

    {value: 'GRADE', label: 'Grade'},
    {value: 'SpecTreat', label: 'Спеицальное лечение'},
]

export const filterFields = [
    {value: 'DS', label: 'Диагноз', children: dsFields},
    {value: 'PATIENT', label: 'Пациент', children: patientFields},
    {value: 'EVENT', label: 'Событие',children: eventFields }
]
export const opOptions = [
    {value: "cnt", title: "Содержит"},
    {value: "beg", title: "Начинается"},
    {value: "uncnt", title: "Не содержит"},
    {value: "eq", title: "Равно"},
    {value: "uneq", title: "Не равно"},
]
export const stepOption = [
    {value: "1", title: "[1] Подозрение на ЗНО", type: "input",              level: 1, col: 1},
    {value: "2", title: "[2] Предварительный диагноз",                       level: 3},
    {value: "3", title: "[3] Подтверждённый диагноз",                        level: 4},
    {value: "4", title: "[4] Лечение",                                       level: 5, col: 1.5},
    {value: "5", title: "[5] Паллиативный сценарий (в т.ч. ДН)",             level: 6, col: 3},
    {value: "6", title: "[6] Реабилитация",                                  level: 6, col: 2},
    {value: "7", title: "[7] Диспансеное наблюдение",  type: "output",       level: 6, col: 1},
    {value: "8", title: "[8] Дисп. или скрининг (1-ый этап)", type: "input", level: 1, col: 3},
    {value: "9", title: "[9] Дисп. или скрининг (2-ой этап)", level: 2, col: 2.5},

    //{value: "10", title: "[10] Снятие с учёта", type: "output", level: 7 },
    {value: "11", title: "[11] Диспансерное наблюдение (предраки)", type: "output", level: 3, col: 3},
]

export const operationTwoQuery = [
    {value: "and", title: "Принадлежит обеим выборкам"},
    {value: "or",  title: "Принадлежит хотя бы одной выборке"},
    {value: "xor", title: "Принадлежит ровно одной выборке"},
    {value: "trg", title: "Если принадлежит первой то принадлежит и второй"},
    {value: "nor",  title: "Не принадлежит ни одной выборке"},
]


export const flkType = [
    {value: "ok", title: "Должно выполняться"},
    {value: "nok",  title: "Не может выполняться"},
    {value: "warn", title: "В случае выполнения предупредить"},
    {value: "nwarn", title: "В случае не выполнения предупредить"},
]


export const stepConnection = [
    {source: "1", target: "2", label: ""},
    {source: "8", target: "9", label: ""},
    {source: "9", target: "2", label: ""},
    {source: "2", target: "3", label: ""},
    {source: "3", target: "4", label: ""},
    {source: "3", target: "5", label: ""},
    {source: "4", target: "6", label: ""},
    {source: "4", target: "7", label: ""},
    {source: "9", target: "11", label: ""},
    {source: "4", target: "5", label: ""},
    {source: "", target: "5", label: ""},
]

export const moType = [
    {value: "1", title: "Прикрепления (общая)"},
    {value: "2", title: "Прикрепления (онко)"},
    {value: "3", title: "Текущая"},
]